/*
 * Wake header — mobile menu.
 *
 * The panel is hidden with the [hidden] attribute so it stays out of the
 * accessibility tree when closed. Opening unhides it a frame before the open
 * class lands, so the drop-down transition has a starting position to animate
 * from; closing waits for the transition before hiding it again.
 */

(function () {
  function init(scope) {
    const root = scope || document;
    const menu = root.querySelector('[data-wake-menu]');
    const toggle = root.querySelector('[data-wake-menu-toggle]');
    if (!menu || !toggle || toggle.dataset.wakeBound) return;
    toggle.dataset.wakeBound = 'true';

    const panel = menu.querySelector('.wake-menu__panel');
    let closeTimer = null;

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      menu.hidden = false;
      /* Force a reflow so the closed transform is committed before the open
         class lands, giving the transition a start position. A rAF would do
         the same but is throttled in background tabs. */
      void menu.offsetHeight;
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      if (!panel) {
        menu.hidden = true;
        return;
      }

      /* transitionend alone is unreliable if the panel is mid-flight or the
         user prefers reduced motion, so a timeout backs it up. */
      const finish = function () {
        if (!menu.classList.contains('is-open')) menu.hidden = true;
      };
      panel.addEventListener('transitionend', finish, { once: true });
      closeTimer = setTimeout(finish, 400);
    }

    toggle.addEventListener('click', function () {
      if (menu.hidden) open();
      else close();
    });

    root.querySelectorAll('[data-wake-menu-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });

    /* The scrim, but not the panel sitting on top of it. */
    menu.addEventListener('click', function (event) {
      if (event.target === menu) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) close();
    });
  }

  /* Sticky header, modelled on Dawn's own.

     Near the top the wrapper is left in normal flow. Once you scroll past it,
     scrolling down makes it sticky and parks it at -height with no transition
     (invisible, because it is already off-screen), and scrolling up drops it
     back to top: 0 with a short transition. Only the reveal is animated. */
  function initStickyHeader() {
    const bar = document.querySelector('.wake-header-bar--sticky');
    if (!bar || bar.dataset.wakeSticky) return;
    bar.dataset.wakeSticky = 'true';

    const sticky = bar.closest('.shopify-section') || bar.parentElement;
    if (!sticky) return;

    const menu = document.querySelector('[data-wake-menu]');
    let headerTop = 0;
    let headerBottom = 0;
    let lastY = window.scrollY;
    let ticking = false;

    function measure() {
      /* Read the resting position, not the stuck one. */
      const wasSticky = sticky.classList.contains('wake-header-sticky');
      if (wasSticky) sticky.classList.remove('wake-header-sticky');
      headerTop = sticky.offsetTop;
      headerBottom = headerTop + sticky.offsetHeight;
      bar.style.setProperty('--wake-header-height', sticky.offsetHeight + 'px');
      sticky.style.setProperty('--wake-header-height', sticky.offsetHeight + 'px');
      if (wasSticky) sticky.classList.add('wake-header-sticky');
    }

    function hide() {
      sticky.classList.remove('animate');
      sticky.classList.add('wake-header-sticky', 'is-hidden');
    }

    function reveal() {
      sticky.classList.add('wake-header-sticky', 'animate');
      sticky.classList.remove('is-hidden');
    }

    function reset() {
      sticky.classList.remove('wake-header-sticky', 'is-hidden', 'animate');
    }

    function update() {
      ticking = false;
      const y = window.scrollY;

      /* The menu hangs off the bar, so the bar has to stay while it is open. */
      if (menu && !menu.hidden) {
        reveal();
        lastY = y;
        return;
      }

      if (y <= headerTop) {
        reset();
      } else if (y > lastY && y > headerBottom) {
        hide();
      } else if (y < lastY && y > headerBottom) {
        reveal();
      }

      lastY = y;
    }

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initStickyHeader();
    });
  } else {
    init();
    initStickyHeader();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
